var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFilePlus4 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.25,
    height: 15,
    viewBox: "0 0 11.25 15",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "file-plus",
    d: "M9.375,14.063h-7.5a.936.936,0,0,1-.937-.938V1.875A.936.936,0,0,1,1.875.938h3.75V4.219A1.407,1.407,0,0,0,7.031,5.625h3.281v7.5A.936.936,0,0,1,9.375,14.063ZM7.031,4.688a.47.47,0,0,1-.469-.469V.952a.447.447,0,0,1,.217.123l3.4,3.4a.461.461,0,0,1,.123.217ZM1.875,0A1.877,1.877,0,0,0,0,1.875v11.25A1.877,1.877,0,0,0,1.875,15h7.5a1.877,1.877,0,0,0,1.875-1.875V4.8a1.406,1.406,0,0,0-.413-.993L7.444.413A1.406,1.406,0,0,0,6.451,0ZM5.156,12.188a.469.469,0,0,0,.938,0V10.312H7.969a.469.469,0,1,0,0-.937H6.094V7.5a.469.469,0,0,0-.938,0V9.375H3.281a.469.469,0,1,0,0,.937H5.156Z",
    fill: "#0078c9"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFilePlus4);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/file-plus-4.f9039f64bee4d68abc9dd8840ec710d9.svg";